import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/loader/loader";
import BreadCrumbsComp from "../../../components/navigator/breadcrumbs";
import { public_news_details, public_news_list } from "../public.api";
import ReactHtmlParser from "react-html-parser";
import "./style.css";
import CustomIcons from "../../../components/icons/kIcons.component";

export default function Newsdetail(props) {
  let fromHome = sessionStorage.getItem("continueFrom");
  let lang = props.state.language;
  const newsParams = useParams();
  const [data, setData] = useState(props.data);
  const [othNews, setOtherNews] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const apiBase = process.env.REACT_APP_BASE_URL;
  const backendBase = apiBase ? new URL(apiBase).origin : "";
  const [url, setUrl] = useState(props.url);
  const fetchEventDetails = (id) => {
    let newsData = [];
    setIsActive(true);
    public_news_details(id).then((res) => {
      newsData = res.data[0];
      setIsActive(false);
      setData(newsData);
      setUrl(res.current_url);
    });
  };
  const fetchOther = () => {
    public_news_list().then((res) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const filtered = res.data.filter((item) => {
        const notificationDateStr =
          item?.[lang]?.notification_date ||
          item?.en?.notification_date ||
          item?.ma?.notification_date;
        if (!notificationDateStr) return false;
        const notificationDate = new Date(notificationDateStr);
        if (Number.isNaN(notificationDate.getTime())) return false;
        notificationDate.setHours(0, 0, 0, 0);
        return notificationDate >= today;
      });
      setOtherNews(filtered);
      // setIsActive(false);
      // setUrl(res.current_url);
    });
  };
  useEffect(() => {
    fetchEventDetails(newsParams.id);
  }, []);
  useEffect(() => {
    fetchOther();
  }, []);

  const gotoDetails = (id) => {
    let path = `/news-detail/${id}`;
    props.history.push(path);
    fetchEventDetails(id);
  };
  const handleLink = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  return (
    <>
      {fromHome === "news" && <BreadCrumbsComp section="home" />}
      <Loader open={isActive} />
      <div className="page-bg1 mynews">
        <div>
          <div className="dash-banner">
            <div className="tit-txt">Notification</div>
          </div>
        </div>
        <div className="container newspad">
          <div className="row">
            <div className="col-md-8 deta">
              {/* Refactored Section to match Publications Card Design */}
              <div className="bg-tender p-30">
                <div className="tender-title mb-4">
                  <p className="head" style={{ overflowWrap: "break-word", fontSize: "18px" }}>
                    <u><strong>{data?.[lang]?.Title}</strong></u>
                  </p>
                </div>

                {data?.[lang]?.Description && (
                  <div className="tender-datas row">
                    <div className="col-lg-2 col-md-12 col-sm-12 label">
                      {/* <p>Description</p> */}
                    </div>
                    <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                      <div>{ReactHtmlParser(data?.[lang]?.Description)}</div>
                    </div>
                  </div>
                )}

                {data?.[lang]?.link && (
                  <div className="tender-datas row">
                    <div className="col-lg-4 col-md-12 col-sm-12 label detail-link-label">
                      <p>For More Details, Please Visit the Link.</p>
                    </div>
                    <div className="d-flex col-lg-8 col-md-12 col-sm-12 contentx overf detail-link-content">
                      <p className="blink_me">
                        <CustomIcons iconName={"hand"} />
                      </p>
                      <span className="detail-link-text">
                        &nbsp;
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLink(data[lang]?.link);
                          }}
                          className="break_link"
                        >
                          {data[lang]?.link}
                        </a>
                      </span>
                    </div>
                  </div>
                )}

                {data?.[lang]?.file && (
                  <div className="tender-datas row mt-3">
                    <div className="col-lg-12 col-md-12 col-sm-12 contentx overf text-center">
                      <button
                        type="button"
                        className="btn btn-adaptable-green"
                        onClick={() => {
                          const filePath = data[lang]?.file;
                          if (!filePath) return;
                          const isAbsolute =
                            filePath.startsWith("http://") ||
                            filePath.startsWith("https://");
                          const normalizedPath =
                            !isAbsolute && filePath.startsWith("/")
                              ? filePath.slice(1)
                              : filePath;
                          const fullUrl = isAbsolute
                            ? filePath
                            : backendBase && normalizedPath
                              ? `${backendBase}/${normalizedPath}`
                              : filePath;
                          window.open(fullUrl, "_blank");
                        }}
                      >
                        {props.state.language === "ma" ? "ഡൗൺലോഡ്" : "Download Document"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* <div className="col-md-1 vertical">
        </div> */}
            <div className="col-md-4 morenews">
              <div className="row">
                <h6>Other Notifications</h6>
                <div className="col-12">
                  <hr />
                </div>
                {othNews.map((item) => (
                  <>
                    {item[lang]?.uuid !== newsParams.id && (
                      <div className="col-12 mb-2">
                        <div className="card">
                          <div className="card-body">
                            {item[lang]?.Title}
                            <div className="">
                              <a
                                href="#"
                                onClick={(e) => gotoDetails(item[lang]?.uuid)}
                              >
                                Read More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
